module.exports = __webpack_public_path__ + "static/media/art54.fe63226b.jpg";